import { useId } from 'react';

export default function useStableId(prefix) {
    const baseId = useId();
    const sanitized = baseId.replace(/[^a-z0-9]/gi, '');
    return prefix ? `${prefix}-${sanitized}` : sanitized;
}
